import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { useRouter } from "next/router";
import { createContext, memo, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { isDevOrTestStage } from "~/swr-hooks/utils";
export const initialTableHeaderPositionContext = {
    tableHeaderTopPosition: 0,
    setTableHeaderTopPosition: noop
};
export const TableHeaderPositionContext = /*#__PURE__*/ createContext(initialTableHeaderPositionContext);
export const TableHeaderPositionContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const router = useRouter();
    const [tableHeaderTopPosition, setTableHeaderTopPosition] = useState(0);
    const value = useMemo(()=>({
            tableHeaderTopPosition,
            setTableHeaderTopPosition
        }), [
        tableHeaderTopPosition
    ]);
    const handleResetTableHeaderTopPosition = useCallback(function(_url) {
        let { shallow } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // When a route change happens, we want to reset the offset to 0.
        // We do this because we add the height of elements before the table into this context provider
        // and those values can change between pages.
        if (!shallow) {
            setTableHeaderTopPosition(0);
        }
    }, [
        setTableHeaderTopPosition
    ]);
    useEffect(()=>{
        router.events.on("routeChangeComplete", handleResetTableHeaderTopPosition);
        return ()=>{
            router.events.off("routeChangeComplete", handleResetTableHeaderTopPosition);
        };
    }, [
        handleResetTableHeaderTopPosition,
        router.events
    ]);
    return /*#__PURE__*/ _jsx(TableHeaderPositionContext.Provider, {
        value: value,
        children: children
    });
});
TableHeaderPositionContextProvider.displayName = "TableHeaderPositionContextProvider";
export const TableHeaderPositionContextConsumer = TableHeaderPositionContext.Consumer;
export const useTableHeaderPositionContext = ()=>{
    const context = useContext(TableHeaderPositionContext);
    if (context === initialTableHeaderPositionContext) {
        const error = "useTableHeaderPositionContext must be used within a TableHeaderPositionContextProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
